import { CopyText } from "../components/header/HeaderParts";

const ReadOnlyAddress = ({address1, address2, city, state, zip, county, copyable = false}) => {
    if (!copyable) {
      return (
        <>
        {address1}{address2 ? ", " : ""}{address2 ? address2 : ''}<br />{city}{city ? ", " : ""}{state}&nbsp;{zip}{county ? <><br />{county} County</> : null}
        </>
      );
    }

    // Each component is individually copyable
    return (
      <>
      <CopyText text={address1} label="address">{address1}</CopyText>
      {address2 ? <>{", "}<CopyText text={address2} label="address line 2">{address2}</CopyText></> : null}
      <br />
      <CopyText text={city} label="city">{city}</CopyText>{city ? ", " : ""}
      <CopyText text={state} label="state">{state}</CopyText>{" "}
      <CopyText text={zip} label="zip">{zip}</CopyText>
      {county ? <><br /><CopyText text={county} label="county">{county}</CopyText> County</> : null}
      </>
    );
}

export default ReadOnlyAddress;
